import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { log } from 'framework/script_utilities/dev-decorators';

@autoinject
export class EventHelper {
  constructor(private ea: EventAggregator) { }

  @log('debug')
  publish(event: any, data?: any) {
    this.ea.publish(event, data);
  }

  subscribe<T>(event: { new(...args: any[]): T } | string, callback: (eventData: T) => any): Subscription {
    return this.ea.subscribe(event, callback);
  }

  unsubscribe(from: Subscription | Subscription[]): void {
    if (!Array.isArray(from)) from = [from]; from.forEach(s => s.dispose());
  }
}

export { Subscription };
